/**
 * This file is here to centralize all of our mock data.
 * This file will be removed once we have BE.
 *
 * @todo remove file once we have a working BE.
 */

export const mockCertData = [{
  _id: '11ekdw094de1',
  firstname: 'Chris',
  lastname: 'Lee',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Valid',
  certificateType: 'user',
}, {
  _id: '1298wekdwidhe1',
  firstname: 'Tom',
  lastname: 'Hall',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Expired',
  certificateType: 'user',
}, {
  _id: '32321ekdw091',
  firstname: 'Rafaela',
  lastname: 'Diaz',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Valid',
  certificateType: 'user',
}, {
  _id: '32321ekdw091',
  firstname: 'Laura',
  lastname: 'Jones',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Valid',
  certificateType: 'user',
}, {
  _id: '073fekdw32e1',
  firstname: 'Tom',
  lastname: 'Smith',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Valid',
  certificateType: 'user',
}, {
  _id: 'ntsdwidhe1',
  firstname: 'Tali',
  lastname: 'Ames',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Valid',
  certificateType: 'user',
}, {
  _id: 'n0s2cvdwi451',
  firstname: 'Sol',
  lastname: 'Acme',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Revoked',
  certificateType: 'user',
}, {
  _id: '8v35kdw094de1',
  firstname: 'Chris',
  lastname: 'Lee',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Expired',
  certificateType: 'user',
}, {
  _id: 'mn0ekdwidhe1',
  firstname: 'Tom',
  lastname: 'Hall',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Revoked',
  certificateType: 'user',
}, {
  _id: 'x5221ekdw091',
  firstname: 'Rafaela',
  lastname: 'Diaz',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Valid',
  certificateType: 'user',
}, {
  _id: 'm802ekdw091',
  firstname: 'Laura',
  lastname: 'Jones',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Valid',
  certificateType: 'user',
}, {
  _id: '25wekdw32e1',
  firstname: 'Tom',
  lastname: 'Smith',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Valid',
  certificateType: 'user',
}, {
  _id: 'vc390wekdwidhe1',
  firstname: 'Rob',
  lastname: 'Alles',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Revoked',
  certificateType: 'user',
}, {
  _id: 'vd17cvdwi451',
  firstname: 'Sol',
  lastname: 'Acme',
  deviceName: null,
  deviceOs: null,
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: null,
  status: 'Valid',
  certificateType: 'user',
}, {
  _id: '667dw094de1',
  firstname: 'Chris',
  lastname: 'Lee',
  deviceName: 'clee-MacBook-8495',
  deviceOs: 'macOS',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '00:fd:748:32991:39292',
  status: 'Revoked',
  certificateType: 'device',
}, {
  _id: '1298wekdwidhe1',
  firstname: 'Tom',
  lastname: 'Hall',
  deviceName: 'thall-Mac-3151',
  deviceOs: 'macOS',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '1c:4d:748:3ds91:39292',
  status: 'Revoked',
  certificateType: 'device',
}, {
  _id: '98wededdw091',
  firstname: 'Rafaela',
  lastname: 'Diaz',
  deviceName: 'rdiaz-Len-2187',
  deviceOs: 'Windows',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '43:3d:748:32991:39292',
  status: 'Expired',
  certificateType: 'device',
}, {
  _id: '3cdfewekdw091',
  firstname: 'Laura',
  lastname: 'Jones',
  deviceName: 'ljones-Len-2187',
  deviceOs: 'Linux',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '1g:5h:748:3f991:39292',
  status: 'Revoked',
  certificateType: 'device',
}, {
  _id: 'eqwdsaekdw32e1',
  firstname: 'Tom',
  lastname: 'Smith',
  deviceName: 'tsmith-del-0321',
  deviceOs: 'Windows',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: 'c5:m7:df8:cd431:392192',
  status: 'Expired',
  certificateType: 'device',
}, {
  _id: '1130wekdwidhe1',
  firstname: 'Rob',
  lastname: 'Alles',
  deviceName: 'ralles-len-2721',
  deviceOs: 'Windows',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '5t:h7:748:3f991:39292',
  status: 'Revoked',
  certificateType: 'device',
}, {
  _id: '3wfwfewqrd451',
  firstname: 'Sol',
  lastname: 'Acme',
  deviceName: 'sacme-Len-4387',
  deviceOs: 'Windows',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '31:m7:df8:3f991:39292',
  status: 'Expired',
  certificateType: 'device',
}, {
  _id: '1dfewfeqwcde1',
  firstname: 'Chris',
  lastname: 'Lee',
  deviceName: 'clee-MacBook-8495',
  deviceOs: 'macOS',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '00:fd:748:32991:39292',
  status: 'Revoked',
  certificateType: 'device',
}, {
  _id: 'dcdadeewidhe1',
  firstname: 'Tom',
  lastname: 'Hall',
  deviceName: 'thall-Mac-3151',
  deviceOs: 'macOS',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '1c:4d:748:3ds91:39292',
  status: 'Revoked',
  certificateType: 'device',
}, {
  _id: 'v41ekdw091',
  firstname: 'Rafaela',
  lastname: 'Diaz',
  deviceName: 'rdiaz-Len-2187',
  deviceOs: 'Windows',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '43:3d:748:32991:39292',
  status: 'Valid',
  certificateType: 'device',
}, {
  _id: '3csc1ekdw091',
  firstname: 'Laura',
  lastname: 'Jones',
  deviceName: 'ljones-Len-2187',
  deviceOs: 'Linux',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '1g:5h:748:3f991:39292',
  status: 'Valid',
  certificateType: 'device',
}, {
  _id: '3123w32e1',
  firstname: 'Tom',
  lastname: 'Smith',
  deviceName: 'tsmith-del-0321',
  deviceOs: 'Windows',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: 'c5:m7:df8:cd431:392192',
  status: 'Revoked',
  certificateType: 'device',
}, {
  _id: '0dedekdwidhe1',
  firstname: 'Rob',
  lastname: 'Alles',
  deviceName: 'ralles-len-2721',
  deviceOs: 'Windows',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '5t:h7:748:3f991:39292',
  status: 'Expired',
  certificateType: 'device',
}, {
  _id: '43213cvdwi451',
  firstname: 'Fred',
  lastname: 'Riel',
  deviceName: 'friel-Len-4387',
  deviceOs: 'Windows',
  resource: 'RADIUS',
  startDate: '03/22/2022',
  endDate: '07/21/2022',
  serialNum: '31:m7:df8:3f991:39292',
  status: 'Revoked',
  certificateType: 'device',
}];

export const mockMappingData = [{
  id: '0001',
  name: 'Marketing Radius Certificates',
  resource: 'Radius',
  userGroups: 1,
}, {
  id: '0002',
  name: 'Customer Radius Certificates',
  resource: 'Custom Radius',
  userGroups: 8,
}, {
  id: '0003',
  name: 'Admin Radius Certificates',
  resource: 'Radius',
  userGroups: 3,
}, {
  id: '0004',
  name: 'Test 1',
  resource: 'Radius',
  userGroups: 2,
}, {
  id: '0005',
  name: 'Test 2',
  resource: 'Radius',
  userGroups: 10,
}, {
  id: '0006',
  name: 'Test 3',
  resource: 'Radius',
  userGroups: 5,
}, {
  id: '0007',
  name: 'Test 4',
  resource: 'Radius',
  userGroups: 2,
}, {
  id: '0008',
  name: 'Test 5',
  resource: 'Radius',
  userGroups: 11,
}, {
  id: '0009',
  name: 'Test 6',
  resource: 'Custom Radius',
  userGroups: 1,
}, {
  id: '0010',
  name: 'Test 7',
  resource: 'Radius',
  userGroups: 7,
}, {
  id: '0011',
  name: 'Test 8',
  resource: 'Radius',
  userGroups: 2,
}, {
  id: '0012',
  name: 'Test 9',
  resource: 'Custom Radius',
  userGroups: 22,
}, {
  id: '0013',
  name: 'Test 10',
  resource: 'Radius',
  userGroups: 15,
}, {
  id: '0014',
  name: 'Test 11',
  resource: 'Radius',
  userGroups: 1,
}];

/**
 * Mocking a Mapping Model For Review Details
 * This is just a guess at the data structure but matches the UX mockups
 */
export const mockMappingModel = {
  name: '',
  resource: 'JumpCloud Radius',
  userGroups: ['Group 1', 'Group 2', 'Group 3'],
  startDate: '2022-02-01T16:58:20.307Z',
  certificates: ['Cert 1', 'Cert 2', 'Cert 3', 'Cert 4'],
  additionalSettings: ['Auto Provision', 'Auto Reissue'],
};

export default {
  mockCertData,
  mockMappingData,
  mockMappingModel,
};
